import { Record } from 'immutable';
export const makeEvaluationLicenseType = Record({
  type: 'evaluation',
  expiry: -1,
  isAutoRenewal: false
});
export const makeAutoRenew = Record({
  isAutoRenewal: true
});
export const makeNotAutoRenew = Record({
  isAutoRenewal: false,
  endDate: -1
});
export const makeSubscriptionLicenseType = Record({
  type: 'subscription',
  renewalType: makeAutoRenew()
});